import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=65b587ea&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=ts"
export * from "./textarea.vue?vue&type=script&lang=ts"
import style0 from "./textarea.vue?vue&type=style&index=0&id=65b587ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b587ea",
  null
  
)

export default component.exports